import * as React from 'react';
import { IMAGE_PATH } from 'util/util';
import './CheckBox.css';

export interface ICheckBoxProps {
  checked: boolean;
  label: string;
  onClick: (ev: React.MouseEvent<HTMLDivElement>) => void;
}

export const ICO_USER = 'ico_user';
export const ICO_PASSWORD = 'ico_password';

declare var Waves: any;

class CheckBox extends React.Component<ICheckBoxProps, object> {

  public componentDidMount() {
    Waves.attach('.checkbox img', 'waves-light');
  }

  public render() {
    const { checked, label, onClick } = this.props;



    return (
      <div className="checkbox">
        <div className="checkboxIco" onClick={onClick}>
          <img src={checked === true ? (IMAGE_PATH + 'color1_16_checkbox_checked@3x.png') : (IMAGE_PATH + 'color1_16_checkbox_uncheck@3x.png')} />
          <label>{label}</label>
        </div>
      </div >

    );
  }
}

export default CheckBox;


// WEBPACK FOOTER //
// ./src/components/CheckBox.tsx